import styled from 'styled-components'

const Title = styled.h1`
  letter-spacing: 0.5px;
  color: #f5a623;
  opacity: 1;
  text-align: center;
  font-size: 30px;
  margin-bottom: 10px;

  @media (max-width: 830px) {
    font-size: 20px;
  }
`

export default Title
